import {
  ModalCommentSectionDocument,
  ModalCommentSectionQuery,
  SaveComment_Input,
  SaveCommentMutation,
  useSaveCommentMutation
} from 'generated/graphql';
import _ from 'lodash';
import {
  appFormUtil,
  gqlCacheUtil
} from 'modules/common';
import React, { useEffect } from 'react';

export type IFormState = {
  description: string;
  id: string;
  taskId: string;
};

const initialState = {
  description: '',
  id: '',
  taskId: ''
};

export function useFormState(id: string, taskId: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      description: {
        label: 'Description',
        type: 'text'
      },
      id: {
        label: 'Id',
        type: 'text'
      },
      taskId: {
        label: 'Task id',
        type: 'text'
      }
    }
  });

  useEffect(() => {
    if (taskId !== '') {
      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'taskId',
          value: taskId
        }
      });
    }
  });

  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useSaveComment() {
  const [
    fnMutate,
    tuple
  ] = useSaveCommentMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (input: SaveComment_Input) => {
      await fnMutate({
        variables: {
          input
        },
        updateQueries: {
          ...gqlCacheUtil.genUpdateQueryMap<ModalCommentSectionQuery, SaveCommentMutation>(
            ModalCommentSectionDocument, (prevState, { mutationResult, queryVariables }) => {
              const existingComments = prevState.task?.comments ?? [];
              const newComment = mutationResult.data?.saveComment;
              if (!newComment) {
                return {
                  ...prevState
                };
              }
              return {
                ...prevState,
                task: {
                  ...prevState.task,
                  id: queryVariables.taskId ?? '',
                  comments: _.compact([
                    ...existingComments,
                    newComment
                  ])
                }
              };
            }
          )
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
